module.exports = __webpack_public_path__ + "img/Logo_spalm_branca.9f20d243.svg";